import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Sidebar = (props) => {
  var { isOpen, onClose } = props;
  var { company, logout } = useAuth();
  var navigate = useNavigate();

  var handleLogout = function () {
    logout();
    navigate('/login');
  };

  var navItems = [
    { to: '/dashboard', label: '📊 Dashboard' },
    { to: '/leads', label: '⚡ Leads' },
    { to: '/customers', label: '👥 Customers' },
    { to: '/integrations', label: '⚙️ Integrations' },
  ];

  return (
    <aside
      className={
        'fixed inset-y-0 left-0 z-30 w-64 bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 ' +
        (isOpen ? 'translate-x-0' : '-translate-x-full')
      }
    >
      <div className="flex flex-col h-full">
        {/* Logo — Vasify CRM */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <img
              src="/logo.jpg"
              alt="Vasify"
              className="w-20 h-12 rounded-lg object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div
              className="w-8 h-8 rounded-lg items-center justify-center text-white text-sm font-bold hidden"
              style={{ backgroundColor: '#25D366', display: 'none' }}
            >
              V
            </div>
            <span className="text-xl font-bold text-gray-900">
              Vasify <span style={{ color: '#25D366' }}>CRM</span>
            </span>
          </div>
          <button onClick={onClose} className="lg:hidden text-gray-400 hover:text-gray-600 text-xl">
            ✕
          </button>
        </div>

        {/* Company info */}
        <div className="px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-medium text-gray-900 truncate">{company ? company.name : ''}</p>
          <p className="text-xs text-gray-500 truncate">{company ? company.email : ''}</p>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {navItems.map(function (item) {
            return (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={onClose}
                className={function (navData) {
                  return (
                    'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200 ' +
                    (navData.isActive
                      ? 'text-green-700'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900')
                  );
                }}
                style={function (navData) {
                  return navData.isActive ? { backgroundColor: '#DCF8C6' } : {};
                }}
              >
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-3 border-t border-gray-200">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 transition-colors duration-200"
          >
            🚪 Logout
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;